import { GetEventQueryResult } from "lib/graphql-generated";
import { useUser } from "lib/hooks/use-user";
import { InPersonEventTickets } from "./event-in-person-tickets";
import { OnlineEventTickets } from "./event-online-tickets";

interface Props {
  event: GetEventQueryResult["data"]["events"][0];
}

export const EventTicketSection = ({ event }: Props) => {
  return (
    <>
      <section
        className={`col-span-full mt-8bg-yellow-light pt-6 pb-8 md:px-12`}>
        <h2 className='header text-lg text-center mb-2 '>Book Now</h2>
        <article className='bg-opacity-40 bg-white overflow-hidden rounded-lg'>
          {!event.is_online_only ? (
            <InPersonEventTickets event={event} />
          ) : null}
          {!event.is_in_person_only ? (
            <OnlineEventTickets event={event} />
          ) : null}
        </article>
      </section>
    </>
  );
};
